module.exports = __webpack_public_path__ + "img/pi-2-4-2.8dd35040.jpg";